(function () {
  const vooPriceElement = document.querySelector('.voo-price');
  const btnPriceElement = document.querySelector('.voo-product-form__btn-price');
  const qtyInput = document.querySelector('.price-per-item__container .quantity__input');

  if (vooPriceElement) {
    const regularPriceElement = vooPriceElement.querySelector('.price-item--regular');

    if (regularPriceElement) {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (btnPriceElement) {
            const totalPrice = (parseFloat(mutation.target.textContent.replace(/[^0-9.]/g, '')) * qtyInput.value) / 100;
            btnPriceElement.textContent = `${window.countryCurrency.symbol}${totalPrice.toFixed(2).replace('.', ',')}`;
          }
        });
      });

      const config = { attributes: true, childList: true, subtree: true };
      observer.observe(regularPriceElement, config);
    }

    const priceObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const untilPriceCaption = vooPriceElement.querySelector('.unit-price.caption .price-item');
        const productFormUnitPrice = document.querySelector('.product-form__unit_price');

        if (untilPriceCaption && productFormUnitPrice) {
          if (untilPriceCaption.textContent.includes('ml')) {
            productFormUnitPrice.innerHTML = untilPriceCaption.innerHTML;
          }
        }
      });
    });

    priceObserver.observe(vooPriceElement, { childList: true, subtree: true });
  }
})();

const mainContentProduct = document.getElementById('MainContent');

if (mainContentProduct) {
  mainContentProduct.addEventListener('click', (event) => {
    const vooProductOptionItem = event.target.classList.contains('voo-product-option__item');
    const dataHandle = event.target.getAttribute('data-handle');
    const vooMainProduct = document.querySelector('.voo-main-product');

    if (vooProductOptionItem) {
      event.preventDefault();
      fetch(dataHandle)
        .then((response) => response.text())
        .then((data) => {
          const domParser = new DOMParser();
          const htmlMarkup = domParser.parseFromString(data, 'text/html');
          const markupVooMainProduct = htmlMarkup.querySelector('.voo-main-product');

          if (markupVooMainProduct && vooMainProduct) {
            vooMainProduct.innerHTML = markupVooMainProduct.innerHTML;
          }

          window.history.replaceState({}, '', dataHandle);
        })
        .catch((error) => {
          console.error('Fetch error:', error);
        });
    }
  });
}
